import axios from 'axios';

export class HttpService {
  constructor(baseUrl) {
    this.apiKeys = [];
    const token = localStorage.getItem('auth_token');
    const headers = token ? 
      { 
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('auth_token')
        }
      } : {};
    this.instance = axios.create({
      baseURL: baseUrl,
      ...headers,
    });
  }

  setResponseInterceptor(resolve, reject) {
    this.instance.interceptors.response.use(resolve, reject);
  }

  setToken(token) {
    this.instance.defaults.headers['Authorization'] = 'Bearer ' + token;
  }

  removeToken() {
    delete this.instance.defaults.headers['Authorization'];
  }

  setApiKey(key) {
    this.instance.defaults.headers['APIKey'] = key;
  }

  delay() {
    const delayTime = 1000;
    return new Promise(res => setTimeout(res, delayTime));
  }

  async get(endpoint, params) {
    const response =
      typeof params === 'undefined'
        ? await this.instance.get(endpoint)
        : await this.instance.get(endpoint, { params });
    return response;
  }

  async post(endpoint, body, params) {
    const { data } = await this.instance.post(endpoint, body, params ? { params } : null);
    return data;
  }

  async put(endpoint, body) {
    const response = await this.instance.put(endpoint, body);
    return response;
  }

  async delete(endpoint, params) {
    const response = await this.instance.delete(endpoint, { params });
    return response;
  }
}
